import { inject, Injectable } from '@angular/core';
import {
  DataService as CoreDataService,
  Query,
  QueryObjectsModel,
} from '@barthauer/abc/core/data';
import { BehaviorSubject, Observable, of} from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';
import { GlobalRole } from '../user-right/user-right.component';
import { ObjectKeys } from './data.service';

@Injectable({
  providedIn: 'root',
})

export class PermissionService {
  private readonly coreDataService =inject(CoreDataService);
  private roleSubject = new BehaviorSubject<GlobalRole>(null);

  public setRole(role: GlobalRole): void {
    this.roleSubject.next(role);
  }

  public getRole(): Observable<GlobalRole> {
    return this.roleSubject.asObservable();
  }
  public LoadPermission = (roleName: string): Observable<any> => {
    const mainQuery: Query = new Query();
    mainQuery.ObjectType = ObjectKeys.USER_ROLE_PERMISSION;
    mainQuery.Columns = [
      this.coreDataService.createQueryColumn('Id'),
      this.coreDataService.createQueryColumn('IdRefAddress'),
      this.coreDataService.createQueryColumn('Name'),
      this.coreDataService.createQueryColumn('Context'),
      this.coreDataService.createQueryColumn('CanCreate'),
      this.coreDataService.createQueryColumn('CanUpdate'),
      this.coreDataService.createQueryColumn('CanDelete'),
      this.coreDataService.createQueryColumn('CanView'),
      this.coreDataService.createQueryColumn('Context'),
    ];
    mainQuery.OPath = `IdRefAddress='${sessionStorage.getItem('profileAddressId')}' And Name='${roleName}'`
    const subQuery: Query = new Query();
    subQuery.Name = 'ChildUserRolePermissions';
    subQuery.OPath = 'ChildUserRolePermissions';
    subQuery.Columns = [
      this.coreDataService.createQueryColumn('Id'),
      this.coreDataService.createQueryColumn('IdRefAddress'),
      this.coreDataService.createQueryColumn('Name'),
      this.coreDataService.createQueryColumn('Context'),
      this.coreDataService.createQueryColumn('CanCreate'),
      this.coreDataService.createQueryColumn('CanDelete'),
      this.coreDataService.createQueryColumn('CanView'),
      this.coreDataService.createQueryColumn('Context'),
    ];
    mainQuery.ObjectQueries = [subQuery];
    const query: QueryObjectsModel = new QueryObjectsModel();
    query.ObjectQueries = [mainQuery];
    return this.coreDataService.executeReadObjectsQuery(query)
    .pipe(
      first(),
      map((data)=>{
        if(Array.isArray(data) && data.length>0){
          return data
        }
        return []
      }),
      catchError(()=> of(null))
    )
  };
}
